<template>
    <article class="i-chart">
        <div class="i-chart__container">
            <h2
                class="i-chart__title"
                :title="chartData.name"
                v-html="chartData.name"></h2>
            <radio-tabs
                :tabs="tabs"
                :id="id"
                @tabs-changed="tabHandler" />
        </div>
        <div
            v-if="renderComponent"
            class="i-chart__chart">
            <div
                ref="chart"
                class="i-chart__chart-wrap">
                <apexchart
                    :width="chartWidth"
                    height="490px"
                    type="line"
                    :options="chartOptions"
                    :series="series" />
            </div>
        </div>
    </article>
</template>

<script>
    import RadioTabs from './RadioTabs'

    export default {
        name: 'Chart',
        components: {
            RadioTabs
        },
        props: {
            chartData: {
                type: Object,
                default: () => {}
            },
            id: {
                type: Number,
                default: 1
            }
        },
        data() {
            return {
                renderComponent: true,
                tabs: ['Квартал', 'Год'],
                choosenPeriod: 'Квартал',
                chartWidth: '100%',
                operator: ' min ',
                series: [
                    {
                        name: "Норматив Н1 = min 11,5%",
                        data: [24, 22.5, 22.4, 17.2, 23.4, 21.8, 16.4, 15.7, 16]
                    },
                    {
                        name: "Норматив Н1 = min 11,5%",
                        data: [11, 11, 11, 11, 11.5, 11.5, 11.5, 11.5, 12]
                    },
                ],
                chartOptions: {
                    chart: {
                        fontFamily: 'Gilroy-medium, Arial, sans-serif',
                        type: 'line',
                        toolbar: {
                            show: false
                        },
                    },
                    colors: ['#A3D562', '#EEA20F'],
                    dataLabels: {
                        enabled: true,
                        offsetY: -8,
                        style: {
                            colors: ['#252628', 'transparent'],
                            fontSize: '14px',
                            fontWeight: 400,
                        },
                        background: {
                            enabled: false,
                            foreColor: '#252628',
                            borderRadius: 0,
                            padding: 4,
                            opacity: 1,
                            borderWidth: 0,
                            borderColor: 'transparent'
                        },
                        formatter: function(val, opt) {
                            return `${val.toString().replace('.', ',')}%`
                        },
                    },
                    stroke: {
                        curve: 'smooth',
                        width: [3, 3],
                        dashArray: [0, 0]
                    },
                    grid: {
                        borderColor: '#e7e7e7',
                        strokeDashArray: 10,
                        row: {
                            colors: ['transparent'],
                            opacity: 1
                        },
                        column: {
                            colors: ['transparent'],
                            opacity: 1
                        },
                        padding: {
                            left: 24,
                            bottom: 25
                        },
                        xaxis: {
                            lines: {
                                show: true
                            }
                        },   
                        yaxis: {
                            lines: {
                                show: true
                            }
                        },
                    },
                    markers: {
                        size: 5,
                        colors: ['#fff', 'transparent'],
                        strokeColors: ['#A3D562', 'transparent'],
                        strokeWidth: 3,
                        strokeOpacity: 1,
                        strokeDashArray: 0,
                        fillOpacity: 1,
                        discrete: [],
                        shape: "circle",
                        radius: 2,
                        offsetX: 0,
                        offsetY: 0,
                        onClick: undefined,
                        onDblClick: undefined,
                        showNullDataPoints: true,
                        hover: {
                            size: 5,
                            sizeOffset: 5
                        }
                    },
                    xaxis: {
                        categories: [
                            'I кв 2021',
                            'II кв 2021',
                            'III кв 2021',
                            'IV кв 2021',
                            'I кв 2022',
                            'II кв 2022',
                            'III кв 2022',
                            'IV кв 2022',
                            'I кв 2023',
                        ],
                        labels: {
                            style: {
                                colors: ['#6D6D6D'],
                                fontSize: '12px',
                                cssClass: 'apexcharts-xaxis-label',
                            },
                            offsetY: 8,
                        },
                        axisTicks: {
                            show: true,
                            borderType: 'solid',
                            color: '#C8C8C8',
                            height: 8,
                            offsetX: 0,
                            offsetY: 16
                        },
                        tooltip: {
                            enabled: false,
                        },
                    },
                    yaxis: {
                        min: 3,
                        max: 30,
                        tickAmount: 5,
                        labels: {
                            show: false,
                            align: 'left',
                            style: {
                                colors: ['#6D6D6D'],
                                fontSize: '12px',
                            },
                            formatter: (value, opt) => {
                                if (typeof opt == 'number') {
                                    return `${value.toString().split('.')[0]}%`
                                }

                                let formatedVal = value.toFixed(1)
                                return `${formatedVal.toString().replace('.', ',')}%`
                            },
                        }
                    },
                    annotations: {
                        yaxis: [
                            {
                                y: 11.5,
                                borderColor: 'transparent',
                                label: {
                                    style: {
                                        color: '#252628',
                                        background: 'transparent',
                                        fontSize: '14px',
                                        fontWeight: 400
                                    },
                                    text: '\u00A0\u00A0\u00A0Норматив Н1 > 11,5%',
                                    borderWidth: 0,
                                    position: 'left',
                                    textAnchor: 'start',
                                }
                            }
                        ]
                    },
                    tooltip: {
                        enabled: true,
                        shared: false,
                        style: {
                            fontSize: '12px',
                        },
                        marker: {
                            show: false,
                        },
                        y: {
                            formatter: (value) => {
                                return ''
                            },

                            title: {
                                formatter: (seriesName, obj) => {
                                    return `Норматив ${this.chartData.name.split(' ')[0].split(',')[0]} = ${this.operator} ${obj.series[1][obj.dataPointIndex]}%`
                                }
                            }
                        }
                    },
                    zoom: {
                        enabled: false
                    },
                    responsive: [
                        {
                            breakpoint: 1199,
                            options: {
                                chart: {
                                    height: '390px',
                                    grid: {
                                        padding: {
                                            left: 12
                                        }
                                    }
                                }
                            },
                        },
                        {
                            breakpoint: 767,
                            options: {
                                chart: {
                                    height: '290px',
                                }
                            },
                        }
                    ]
                },
            }
        },
        methods: {
            forceRender () {
                this.renderComponent = false
                this.$nextTick(() => this.renderComponent = true)
            },
            setChartWidth () {
                const LEFT_COLUMN = 50
                const POINT_TICK = 80
                const totalWidth = LEFT_COLUMN + POINT_TICK * this.series[0].data.length

                if (this.$refs.chart && this.$refs.chart.offsetWidth < totalWidth ) {
                    this.chartWidth = totalWidth
                } else {
                    this.chartWidth = '100%'
                }
            },

            setCurrentOperator (direction) {
                if (direction === 'more') {
                    this.operator = ' min '
                } else if (direction === 'less') {
                    this.operator = ' max '
                }
            },

            setLeftColumnLimits (minLimit, minVal, maxLimit, maxVal) {
                if (maxVal <= maxLimit ) {
                    this.chartOptions.yaxis.max = maxLimit + 3
                } else {
                    this.chartOptions.yaxis.max = maxVal + 3
                }

                if (minLimit < minVal) {
                    if (minLimit - 3 < 0) return this.chartOptions.yaxis.min = 0
                    this.chartOptions.yaxis.min = minLimit - 3
                } else {
                    if (minVal - 3 < 0) return this.chartOptions.yaxis.min = 0
                    this.chartOptions.yaxis.min = minVal - 3
                }
            },


            setChartData () {
                const filteredData = this.chartData
                console.log(this.chartData)
                const years = Object.keys(filteredData.items)
                let dataValues = {}
                let categoriesQuarter = []
                let currentLimits = {}

                years.forEach(el => {
                    dataValues[el] = Object.values(filteredData.items[el]).map(item => item.standart_value.split(',') ? Number(item.standart_value).toFixed(1).replace(',', '.') : Number(item.standart_value).toFixed(1))
                    currentLimits[el] = Object.values(filteredData.items[el]).map(item => item.limit.split(',') ? Number(item.limit.replace(',', '.')) : Number(item.limit))
                    categoriesQuarter.push(Object.values(filteredData.items[el]).map(item => item.name))

                    if (filteredData.items[el][4]) {
                        dataValues[el].middleVal = filteredData.items[el][4].standart_value
                        currentLimits[el].middleVal = filteredData.items[el][4].limit
                    }
                    
                })

                if (this.choosenPeriod === 'Год') {
                    const series_1 = Object.values(dataValues).map(el => el.middleVal)
                    const series_2 = Object.values(currentLimits).map(el => el.middleVal)

                    if (series_1[series_1.length - 1]) {
                        this.series[0].data = series_1
                        this.series[1].data = series_2
                        this.chartOptions.xaxis.categories = Object.keys(filteredData.items)
                    } else {
                        this.series[0].data = series_1.slice(0, -1)
                        this.series[1].data = series_2.slice(0, -1)
                        this.chartOptions.xaxis.categories = Object.keys(filteredData.items).slice(0, -1)
                    }

                    const maxVal = Math.max.apply(null, this.series[0].data)
                    const minVal = Math.min.apply(null, this.series[0].data)
                    const maxLimit = Math.max.apply(null, this.series[1].data)
                    const minLimit = Math.min.apply(null, this.series[1].data)
                    
                    this.setLeftColumnLimits(minLimit, minVal, maxLimit, maxVal)
                }

                if (this.choosenPeriod === 'Квартал') {
                    this.chartOptions.xaxis.categories = categoriesQuarter.flat(Infinity)
                    this.series[0].data = Object.values(dataValues).flat(Infinity)
                    this.series[1].data = Object.values(currentLimits).flat(Infinity)

                    const maxVal = Math.max.apply(null, Object.values(dataValues).flat(Infinity))
                    const minVal = Math.min.apply(null, Object.values(dataValues).flat(Infinity))
                    const maxLimit = Math.max.apply(null, Object.values(currentLimits).flat(Infinity))
                    const minLimit = Math.min.apply(null, Object.values(currentLimits).flat(Infinity))

                    this.setLeftColumnLimits(minLimit, minVal, maxLimit, maxVal)
                }

                this.setCurrentOperator(filteredData.direction)

                const textLabel = 'Норматив ' + filteredData.name.split(' ')[0].split(',')[0] + ' = ' + this.operator + Object.values(currentLimits)[0][0] + '%'

                this.chartOptions.annotations.yaxis[0].y = Object.values(currentLimits)[0][0]
                this.chartOptions.annotations.yaxis[0].label.text = '\u00A0\u00A0\u00A0' + textLabel

                this.forceRender()
                this.setChartWidth()
            },

            tabHandler (val) {
                this.choosenPeriod = val
                this.setChartData()
            }
        },
        mounted() {
            this.setChartData()
        }
    }
</script>